<template>
  <div
    class="auth-wrapper"
    v-loading="$route.query.token != '' && $route.query.token != null"
    :style="{
      height:
        $route.query.token != '' && $route.query.token != null ? '100vh' : '',
    }"
  >
    <!--Page body-->

    <div
      class="auth-wrapper-inner is-single"
      v-if="$route.query.token == '' || $route.query.token == null"
    >
      <!--Single Centered Form-->
      <div class="single-form-wrap">
        <div class="inner-wrap">
          <!--Form Title-->
          <div class="auth-head">
            <img
              :src="'/static/img/logo_' + $i18n.locale + '.svg'"
              style="width: 200px"
              alt=""
            />
          </div>

          <!--Form-->
          <div class="form-card">
            <div id="signin-form" class="login-form">
              <!-- Input -->
              <div class="field">
                <div class="control has-icon">
                  <input
                    class="input"
                    v-model="form.email"
                    type="text"
                    :placeholder="$t('login.email')"
                    style="
                      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC');
                      background-repeat: no-repeat;
                      background-attachment: scroll;
                      background-size: 16px 18px;
                      background-position: 98% 50%;
                    "
                  />
                  <span class="form-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-user"
                    >
                      <path
                        d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
                      ></path>
                      <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                  </span>
                </div>
              </div>
              <!-- Input -->
              <div class="field">
                <div class="control has-icon">
                  <input
                    class="input"
                    type="password"
                    :placeholder="$t('login.password')"
                    v-model="form.password"
                    style="
                      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAAAXNSR0IArs4c6QAAAPhJREFUOBHlU70KgzAQPlMhEvoQTg6OPoOjT+JWOnRqkUKHgqWP4OQbOPokTk6OTkVULNSLVc62oJmbIdzd95NcuGjX2/3YVI/Ts+t0WLE2ut5xsQ0O+90F6UxFjAI8qNcEGONia08e6MNONYwCS7EQAizLmtGUDEzTBNd1fxsYhjEBnHPQNG3KKTYV34F8ec/zwHEciOMYyrIE3/ehKAqIoggo9inGXKmFXwbyBkmSQJqmUNe15IRhCG3byphitm1/eUzDM4qR0TTNjEixGdAnSi3keS5vSk2UDKqqgizLqB4YzvassiKhGtZ/jDMtLOnHz7TE+yf8BaDZXA509yeBAAAAAElFTkSuQmCC');
                      background-repeat: no-repeat;
                      background-attachment: scroll;
                      background-size: 16px 18px;
                      background-position: 98% 50%;
                    "
                  />
                  <span class="form-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-lock"
                    >
                      <rect
                        x="3"
                        y="11"
                        width="18"
                        height="11"
                        rx="2"
                        ry="2"
                      ></rect>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                  </span>
                </div>
              </div>

              <!-- Submit -->
              <div class="control login">
                <button
                  @click="login"
                  class="
                    button
                    h-button
                    is-primary is-bold is-fullwidth is-raised
                  "
                  :class="loading ? 'is-loading' : ''"
                >
                  {{ $t("login.login") }}
                </button>
              </div>
            </div>
          </div>

          <div class="forgot-link has-text-centered">
            <a
              href="https://www.360hizliokuma.com.tr/sifremi-unuttum"
              target="_blank"
              >{{ $t("login.forgot") }}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data() {
    return {
      form: {
        email: null,
        password: null,
      },
      loading: false,
    };
  },
  methods: {
    login() {
      if (this.loading) return;
      this.loading = true;

      axios
        .post("user/login", this.form)
        .then((res) => {
          axios.defaults.headers.common["authorization"] = res.data.data.token;
          localStorage.setItem("token", res.data.data.token);
          this.$store.state.user = res.data.data.user;
          this.$store.state.token = res.data.data.token;
          window.location.href = "/";
        })
        .catch((err) => {
          if (err.response.data.data === true) {
            this.$confirm(err.response.data.message, "Uyarı", {
              confirmButtonText: "Evet",
              cancelButtonText: "Hayır",
              type: "warning",
            }).then(() => {
              window.location.href = "https://yazilim.360hizliokuma.com";
            });
          } else {
            this.$toast.error(err.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    if (this.$route.query.token != "" && this.$route.query.token != null) {
      axios
        .post("user/directLogin", { token: this.$route.query.token })
        .then((res) => {
          axios.defaults.headers.common["authorization"] = res.data.data.token;
          localStorage.setItem("token", res.data.data.token);
          this.$store.state.user = res.data.data.user;
          this.$store.state.token = res.data.data.token;
          window.location.href = "/";
        })
        .catch((err) => {
          this.$toast.error(err.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Login.vue